const fontSizePtToPx = (fontSize: number) => {
  return fontSize * (96 / 72);
};

// get the value that scales the editor font sizes for comments (we want a font
// size of 14px without altering too much editor CSS which sets the default size
// to 11.6pt)
export const getCommentFontScale = () => {
  return 14 / fontSizePtToPx(11.6);
};
